import gql from 'graphql-tag';

export default gql`
    query GetAllChasisData {
        getAllChasisData {
            id
            sbsId
            jdeId
            oldSBSId
            trailerType
            serviceStatus
            leasedTo
        }
    }
`;
